import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";
import { InspectionForm } from "@/components/site/InspectionForm";
import { Zap, X } from "lucide-react";
import { useState } from "react";

export const InspectionModal = ({ children, defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      {children ? <DialogTrigger asChild>{children}</DialogTrigger> : null}
      <DialogContent
        data-testid="inspection-modal"
        className="max-w-2xl w-[95vw] max-h-[92vh] overflow-y-auto p-0 bg-slate-950 border-white border-2 rounded-none shadow-[0_0_60px_rgba(125,211,252,0.3)]"
      >
        {/* Header bar */}
        <div
          className="relative px-6 py-5 border-b-2 border-red-600"
          style={{
            background:
              "linear-gradient(135deg, #7f1d1d 0%, #0c1a3d 55%, #1e3a8a 100%)",
          }}
        >
          <div className="flex items-center gap-3">
            <Zap size={22} className="text-sky-300 fill-sky-300" />
            <div>
              <div className="font-impact uppercase text-white text-xl sm:text-2xl tracking-tight leading-none">
                Free Roof Inspection
              </div>
              <div className="text-[11px] uppercase tracking-[0.25em] text-sky-300 mt-1">
                No cost · No obligation · Same-week
              </div>
            </div>
          </div>
          <button
            type="button"
            aria-label="Close"
            data-testid="inspection-modal-close"
            onClick={() => setOpen(false)}
            className="absolute top-3 right-3 text-slate-300 hover:text-sky-300 transition-colors"
          >
            <X size={22} />
          </button>
          {/* barber stripe */}
          <div
            aria-hidden
            className="absolute -bottom-[2px] left-0 right-0 h-1"
            style={{
              background:
                "repeating-linear-gradient(90deg, #dc2626 0 22px, #ffffff 22px 26px, #020617 26px 50px, #1e3a8a 50px 54px)",
            }}
          />
        </div>

        <div className="p-6 sm:p-8 bg-slate-950">
          <InspectionForm onDone={() => setTimeout(() => setOpen(false), 2500)} />
        </div>
      </DialogContent>
    </Dialog>
  );
};
